/**
 * Options matching the typed text (case-insensitive, by label), capped at max.
 * An exact label match goes first so creatable selects don't offer to create an existing option.
 */
export const limitOptions = (options, inputValue, max) => {
    const search = (inputValue || '').trim().toLowerCase();
    const matches = [];
    let exact = null;
    for (const option of options || []) {
        const label = String(option.label ?? '').toLowerCase();
        if (search && label === search && !exact) {
            exact = option;
        } else if (!search || label.includes(search)) {
            matches.push(option);
        }
    }
    if (exact) {
        matches.unshift(exact);
    }
    return matches.slice(0, max);
};
